import React, { useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Slider.css";
import Slider from "react-slick";
import Fade from "react-reveal/Fade";
import blog from "../../../Data/blog";
import { Link } from "react-router-dom";

const Blogs = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    initialSlide: 0,

    responsive: [
      {
        breakpoint: 310,
        settings: {
          dots: true,
          arrows: true,
          infinite: true,
          slidesToScroll: 1,
          swipeToSlide: true,
        },
      },
      {
        breakpoint: 750,
        settings: "unslick",
      },
    ],

    afterChange: (current) => setCurrentSlide(current),
  };

  return (
    <Fade bottom>
      {" "}
      <div className="slider-container  relative w-full">
        <Slider {...settings}>
          {blog.map((blog, i) => (
            <article key={i} className="p-2">
              <div className="bg-[#F4F6FD] ">
                <img src={blog.images[0]} alt="" className="w-full" />
                <div className=" px-6 pt-10 pb-12 text-center">
                  <h4 className="text-[#0D1C37] text-xl max-sm:text-2xl mb-6 uppercase text-center font-extrabold">
                    {blog?.title}
                  </h4>
                  <Link to={`/blog-details/${blog.id}`}>
                    <button
                      style={{ boxShadow: "none" }}
                      className="custom_button "
                    >
                      {" "}
                      Read More
                      <i className="fa-solid fa-arrow-right ml-2"></i>
                    </button>
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </Slider>
        <div className="progress-bar absolute bottom-[-13px] left-0 w-full h-1 bg-[#F4F6FD]">
          <div
            className="progress-bar-fill h-full "
            style={{ width: `${((currentSlide + 2) / 3) * 70}%` }}
          />
        </div>
      </div>
    </Fade>
  );
};

export default Blogs;
